// Source: app/scripts/controllers/general.js
Auction.controller('HeaderController', [
  '$scope',
  '$location',
  '$window',
  function ($scope, $location,$window) {
    $scope.isActive = function (viewLocation) {
      var re = new RegExp(viewLocation);
      return re.test($location.path());
    };
  }
]);


Auction.controller('LanguageController', [
  '$scope',
  '$translate',
  '$location',
  'crudService',
  '$window',
  '$timeout',
  function ($scope, $translate, $location, crudService,$window,$timeout) {
    $scope.languages = crudService('languages').query();

    $scope.isActive = function (lang) {
      return $translate.use() == lang;
    };

    $scope.changeLanguage = function (languageKey) {
      $translate.use(languageKey);
      $scope.$root.lang = languageKey;
      moment.lang(languageKey);

      $timeout(function refresh() {
        $window.location.reload();
      }, 500)
    };


  }
]);
